module.exports = __webpack_public_path__ + "static/media/PositiveDot.39df2480.svg";